import React from 'react';

import { MultiSelect } from '../../../components/reusables/FormElements';

import { IJobPostFormData, TJobPostFormField } from '../../../interfaces/job_posts';
import { ISelectDropdownOption } from '../../../interfaces/formElements';
import { ISchool } from '../../../interfaces/services';

interface IJobDetailsFormProps {
    formData: IJobPostFormData;
    setFormData: React.Dispatch<React.SetStateAction<IJobPostFormData>>;
    schools: ISchool[];
    isSchoolsLoading: boolean;
    isFormDisabled: boolean;
}

const JobAudienceForm = (props: IJobDetailsFormProps) => {
    const { formData, setFormData, schools, isSchoolsLoading, isFormDisabled } = props;

    const onChangeMultiSelect = (name: TJobPostFormField, options: ISelectDropdownOption[]) => {
        setFormData(prevData => {
            return {
                ...prevData,
                [name]: { value: options, error: "" }
            };
        });
    };

    const isDisabled = isSchoolsLoading || isFormDisabled;

    return (
        <div className='immployer__details_form_view'>
            <div className="immployer__details_form_inputs__container">
                <div className="immployer__details_form_inputs">
                    <MultiSelect
                        name="associated_schools"
                        label="This job will only be shown to users in the selected school."
                        options={schools?.map((school: ISchool) => ({ value: school.id.toString(), label: school.name })) ?? []}
                        onChange={(options: ISelectDropdownOption[]) => onChangeMultiSelect("associated_schools", options)}
                        values={formData.associated_schools.value}
                        showSelectedCount={true}
                        maxDisplayValues={10}
                        placeholder="Select Schools"
                        length_flex={2}
                        read_only={isDisabled}
                    />
                </div>
            </div>
        </div>
    )
}

export default JobAudienceForm;